export const namespacedPrefix = '[MEALS]';
